
/**
 *  给table赋值，重新遍历新增rowSpan属性，
 * @param {Array} data table的list
 * @param {Array}<String>  merge  为table里面需要合并的属性名称
 * @param {String} referElement 合并行数参照该属性的合并数
 * 需要合并的行的prop必须要有值
 * eg:this.mergeTableRowAndRefer(list, ['ruleName', 'dataOrigin'], 'ruleName');
 */
export const mergeTableRowAndRefer = (data = [], merge = [], referElement = '') => {
  if (!merge || merge.length === 0) {
    return data;
  }
  merge.forEach((m) => {
    const mList = {};
    data = (data || []).map((row, index) => {
      const rowVal = row[m];
      // 如果参照的合并属性值不为空，并且属性不等于参照合并的属性，则rowspan = 该合并属性的rowspan值
      if (referElement && m !== referElement) {
        const { rowspan, colspan } = row[`${referElement}-span`];
        row[`${m}-span`] = {
          rowspan,
          colspan,
        };
      } else if (mList[rowVal] && mList[rowVal].newIndex === index) {
        mList[rowVal].num += 1;
        mList[rowVal].newIndex += 1;
        data[mList[rowVal].index][`${m}-span`].rowspan += 1;
        row[`${m}-span`] = {
          rowspan: 0,
          colspan: 0,
        };
      } else {
        mList[rowVal] = { num: 1, index, newIndex: index + 1 };
        row[`${m}-span`] = {
          rowspan: 1,
          colspan: 1,
        };
      }
      return row;
    });
  });
  return data;
};

// 合并行或列的计算方法
export const objectSpanMethod = ({ row, column }) => {
  const span = `${column.property}-span`;
  if (row[span]) {
    return row[span];
  }
  return true;
};
